import PatientList from '../../../../templates/views/PatientList';

export default {
  path: 'patients/list',
  component: PatientList,
  name: 'PatientList',
  meta: {
    title: t => t('patient.list'),
    loggedInOnly: true
  },
};
